import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=c3becd24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3becd24"]])

export default __exports__